export default __webpack_public_path__ + "static/media/placeholder_dummy2016-pragentur01-de.59835b27.png";